import { useNativeAudioPlayer, MediaItem } from "core/hooks/useNativeAudioPlayer/useNativeAudioPlayer";
import { AudioPlayerControlBar } from "../AudioPlayerControlBar/AudioPlayerControlBar";
import ErrorAlert from "shared/UI/Alerts/ErrorAlert";
import { t } from "i18next";

export const MobileAudioPlayer = ({ mediaItem }: { mediaItem: MediaItem }) => {
  const { isInitialised, playTime, duration, isPlaying, error, play, pause, onSeekMouseDown, onSeekMouseUp, onSeekChange } = useNativeAudioPlayer(
    mediaItem,
    false
  );

  return (
    <>
      <div className="pt-5" key={mediaItem.src}>
        <AudioPlayerControlBar
          disabled={duration === 0}
          position={duration > 0 ? playTime / duration : 0}
          duration={duration}
          isPlaying={isPlaying}
          isLoading={!isInitialised}
          play={play}
          pause={pause}
          onSeekMouseDown={onSeekMouseDown}
          onSeekMouseUp={onSeekMouseUp}
          onSeekChange={onSeekChange}
        />
      </div>
      {error && <ErrorAlert content={t("resourceViewer.player.loadingError")} />}
    </>
  );
};
